export function dataUnavailableAlert(lang: string): string {
  const l = String(lang || "").toLowerCase()
  if (l === "hi") return "डेटा उपलब्ध नहीं"
  if (l === "pa") return "ਡਾਟਾ ਉਪਲਬਧ ਨਹੀਂ"
  return "Data unavailable"
}

export function isDummyXyzProfile(...candidates: Array<string | null | undefined>): boolean {
  const text = candidates.filter(Boolean).join(" ").toLowerCase()
  if (!text) return false
  return /\bxyz\b|\babc\b/.test(text)
}
